import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { createHttpLink } from 'apollo-link-http';
import { onError } from '@apollo/client/link/error';
import { setContext } from 'apollo-link-context';
import { useDispatch } from 'react-redux';
import cookies from 'js-cookie';
import { logout } from '~actions/auth';
import { cookieNames } from '~client/constants';
import { GRAPH_URL } from '~settings/endpoints';
import { useMemo } from 'react';

export const GLOBAL_ERROR_CODE = {
  UNAUTHORIZED: 'UNAUTHORISED',
};

const httpLink = createHttpLink({ uri: GRAPH_URL });

const authLink = setContext((_, { headers }) => {
  const token = cookies.get(cookieNames.token);

  return {
    headers: {
      'Accept-Language': 'en-us',
      Authorization: token ? `Bearer ${token}` : undefined,
      ...headers,
    },
  };
});

const useApolloErrorLink = dispatch => {
  const responseErrorHandlerLink = onError(({ graphQLErrors }) => {
    const errorMessage = graphQLErrors?.[0]?.code?.toUpperCase();

    if (errorMessage === GLOBAL_ERROR_CODE.UNAUTHORIZED) {
      dispatch(logout());
    }
  });

  return responseErrorHandlerLink;
};

const useApolloClient = () => {
  const dispatch = useDispatch();
  const errorLink = useApolloErrorLink(dispatch);
  const link = useMemo(() => from([errorLink, authLink, httpLink]), []);

  return useMemo(
    () =>
      new ApolloClient({
        link,
        cache: new InMemoryCache(),
      }),
    [],
  );
};

export default useApolloClient;
